import { useState, useEffect } from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { getClientById } from '../services/clientService';
import { getPropertyById } from '../services/propertyService';

import { useBreadcrumbStore } from '../store/useBreadcrumbStore';
import { AgentList } from '../components/agents/AgentList';

export default function AgentsPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const clientId = params.get('clientId') || undefined;
  const propertyId = params.get('propertyId') || undefined;

  const [contextName, setContextName] = useState('');
  const setBreadcrumb = useBreadcrumbStore((s) => s.set);

  useEffect(() => {
    if (location.pathname !== '/agents') return;
    if (propertyId && clientId) {
      Promise.all([getPropertyById(propertyId), getClientById(clientId)]).then(([prop, client]) => {
        setContextName(prop.name || propertyId);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: client.name || clientId, path: `/client-detail?clientId=${clientId}` },
          { label: 'Properties', path: `/properties?clientId=${clientId}` },
          { label: prop.name || propertyId },
          { label: 'Agents' },
        ]);
      });
    } else if (propertyId) {
      getPropertyById(propertyId).then((prop) => {
        setContextName(prop.name || propertyId);
        if (prop.clientId) {
          getClientById(prop.clientId).then((client) => {
            setBreadcrumb([
              { label: 'Clients', path: '/clients' },
              { label: client.name || prop.clientId!, path: `/client-detail?clientId=${prop.clientId}` },
              { label: 'Properties', path: `/properties?clientId=${prop.clientId}` },
              { label: prop.name || propertyId },
              { label: 'Agents' },
            ]);
          });
        } else {
          setBreadcrumb([
            { label: 'Properties', path: '/properties' },
            { label: prop.name || propertyId },
            { label: 'Agents' },
          ]);
        }
      });
    } else if (clientId) {
      getClientById(clientId).then((client) => {
        const name = client.name || clientId;
        setContextName(name);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: name, path: `/client-detail?clientId=${clientId}` },
          { label: 'Agents' },
        ]);
      });
    } else {
      setContextName('');
      setBreadcrumb([{ label: 'Agents' }]);
    }
  }, [location.pathname, clientId, propertyId, setBreadcrumb]);

  const title = contextName ? `Agents - ${contextName}` : 'Agents';

  return (
    <IonPage>
      <IonContent>
        <AgentList title={title} clientId={clientId} propertyId={propertyId} />
      </IonContent>
    </IonPage>
  );
}
